<template>
	<div class="p-1 rounded-lg bg-[#303030] sm:w-max">
		<div class="flex flex-col sm:flex-row">
			<button
				v-for="option in options"
				:key="option.value"
				type="button"
				:disabled="disabled"
				class="px-4 py-2 transition rounded-lg"
				:class="
					option.value === value
						? 'bg-neutral-700 text-white'
						: 'text-white/70 hover:text-white hover:bg-neutral-700/40'
				"
				@click="$emit('input', option.value)"
			>
				{{ option.label }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OverviewSegmentedControl',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		value: {
			type: String,
			required: true
		}
	},
	computed: {
		options() {
			return [
				{
					value: 'comparison',
					label: this.$t('personality_results.mode.comparison')
				},
				{
					value: 'applicant',
					label: this.$t('personality_results.mode.candidate')
				},
				{
					value: 'job',
					label: this.$t('personality_results.mode.job_profile')
				}
			]
		}
	}
}
</script>
